var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "120",
          height: "40",
          viewBox: "0 0 150 40",
          fill: "none",
          "aria-labelledby": "pagseguro-icon",
        },
      },
      [
        _c("path", {
          attrs: {
            fill: "#000",
            d: "M47.45 18.661h-2.632l-1.072 5.083h-3.002l2.921-13.717h5.657c2.306 0 3.88 1.612 3.88 3.465 0 3.682-2.933 5.169-5.752 5.169Zm.37-6.626h-1.603l-.99 4.61h1.031c2.017 0 3.866-.452 3.866-2.86.014-1.095-1.13-1.756-2.303-1.756v.006Zm15.37 8.041a19.155 19.155 0 0 0-.493 3.662h-2.903c.042-.515.226-1.481.393-2.428-.74 1.337-1.95 2.654-3.971 2.654-2.078 0-3.128-1.393-3.128-3.292 0-4.63 4.136-7.49 8.077-7.49 1.192 0 2.735.207 3.456.474l-1.431 6.42Zm-2.571-4.98c-2.367 0-4.526 2.507-4.526 5.267 0 .927.329 1.688 1.393 1.688 1.44 0 2.818-1.975 3.395-4.457l.557-2.387a2.275 2.275 0 0 0-.82-.111ZM74.61 22.36c-.928 4.155-2.45 6.05-7.017 6.05-1.216 0-2.424-.195-3.579-.577l.557-2.036a6.186 6.186 0 0 0 2.964.699c2.57 0 3.56-1.357 4.033-3.29l.328-1.359c-.989 1.318-2.016 1.894-3.724 1.894-2.12 0-3.147-1.317-3.147-3.064 0-4.648 4.236-7.467 8.189-7.467a12.88 12.88 0 0 1 3.342.451l-1.947 8.699Zm-2.017-7.242c-2.368 0-4.568 2.429-4.568 5.309 0 .927.328 1.604 1.337 1.604 1.936 0 3.005-2.468 3.437-4.297l.596-2.49a2.68 2.68 0 0 0-.802-.129v.003Zm12.982 1.521c1.481.329 2.428 1.276 2.428 2.716 0 3.54-3.376 4.383-6.214 4.383h-5.083l2.922-13.711h5.495c1.83 0 3.805.835 3.805 2.88 0 2.044-1.356 3.361-3.353 3.732Zm-3.373.947h-1.298l-.925 4.32h1.42c1.727 0 3.518-.535 3.518-2.654 0-1.427-1.604-1.666-2.715-1.666Zm1.604-5.74h-1.707l-.836 3.93h1.462c1.605 0 3.167-.619 3.167-2.449.011-1.153-1.14-1.481-2.086-1.481Zm15.534 8.23a19.139 19.139 0 0 0-.494 3.662h-2.902c.042-.515.225-1.481.39-2.428-.738 1.337-1.95 2.654-3.97 2.654-2.077 0-3.127-1.393-3.127-3.292 0-4.63 4.136-7.49 8.077-7.49 1.192 0 2.735.207 3.457.474l-1.432 6.42Zm-2.572-4.98c-2.367 0-4.526 2.507-4.526 5.267 0 .927.329 1.688 1.393 1.688 1.44 0 2.819-1.975 3.395-4.457l.557-2.387a2.275 2.275 0 0 0-.819-.111Zm14.957 1.81-1.426 6.832h-2.841l1.298-6.213c.092-.35.147-.709.164-1.07 0-.783-.37-1.34-1.359-1.34-1.543 0-2.284 1.38-2.571 2.719l-1.256 5.904h-2.871l1.685-8.024c.171-.761.302-1.53.392-2.306h2.674l-.309 1.833c.989-1.379 2.017-2.036 3.724-2.036 1.707 0 2.819.835 2.819 2.529a6.079 6.079 0 0 1-.123 1.172Zm7.448 1.198 3.25 5.637h-3.25l-2.8-5.414-1.114 5.411h-2.854l3.127-14.825h2.844l-1.83 8.762 4.423-4.259h3.342l-5.138 4.688ZM24.097 33.67c8.89-3.684 13.112-13.876 9.43-22.767-3.683-8.89-13.875-13.113-22.766-9.43C1.87 5.156-2.352 15.348 1.33 24.24c3.683 8.89 13.875 13.113 22.766 9.43Z",
          },
        }),
        _c("path", {
          attrs: {
            fill: "#DDE05B",
            d: "M17.428 29.699c8.002 0 14.49-6.487 14.49-14.489S25.43.721 17.427.721C9.428.721 2.94 7.208 2.94 15.211c0 8.001 6.487 14.488 14.489 14.488Z",
          },
        }),
        _c("path", {
          attrs: {
            fill: "#000",
            d: "M17.428 30.08a15.04 15.04 0 1 1 0-30.08 15.04 15.04 0 0 1 0 30.08Zm0-28.966A13.946 13.946 0 1 0 31.374 15.04 13.96 13.96 0 0 0 17.43 1.09v.025Z",
          },
        }),
        _c("path", {
          attrs: {
            fill: "#9ED5D6",
            d: "M15.003 33.871c6.642 0 12.026-5.384 12.026-12.027 0-6.642-5.384-12.026-12.026-12.026-6.643 0-12.027 5.384-12.027 12.027 0 6.642 5.384 12.026 12.027 12.026Z",
          },
        }),
        _c("path", {
          attrs: {
            fill: "#000",
            d: "M15.028 34.42A12.573 12.573 0 1 1 27.3 24.48a12.58 12.58 0 0 1-12.256 9.94h-.016ZM15 10.36a11.484 11.484 0 1 0 .003 22.967A11.484 11.484 0 0 0 15 10.361Z",
          },
        }),
        _c("path", {
          attrs: {
            fill: "#FFE72D",
            d: "M25.508 29.813a7.462 7.462 0 1 0 0-14.923 7.462 7.462 0 0 0 0 14.923Z",
          },
        }),
        _c("path", {
          attrs: {
            fill: "#000",
            d: "M25.508 30.359a8.007 8.007 0 1 1 8.008-8.008 8.016 8.016 0 0 1-8.008 8.008Zm0-14.923a6.918 6.918 0 1 0-.005 13.836 6.918 6.918 0 0 0 .005-13.836Z",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }